import { Map } from 'immutable';

export function update(id, data) {
    return {
        type: 'SPORT_DATA',
        data,
        id
    };
}

export function bulk(data) {
    return {
        type: 'SPORTS_DATA',
        data
    };
}
